import { createEffect, createMemo, on, onCleanup, onMount } from "solid-js";
import { useWire } from "~/wire";

export const FeatureBaseSDKLink = `!(function(e,t){var a="featurebase-sdk";function n(){if(!t.getElementById(a)){var e=t.createElement("script");(e.id=a),(e.src="https://do.featurebase.app/js/sdk.js"),t.getElementsByTagName("script")[0].parentNode.insertBefore(e,t.getElementsByTagName("script")[0])}};"function"!=typeof e.Featurebase&&(e.Featurebase=function(){(e.Featurebase.q=e.Featurebase.q||[]).push(arguments)}),"complete"===t.readyState||"interactive"===t.readyState?n():t.addEventListener("DOMContentLoaded",n)})(window,document);`;

export const FeatureBaseMessengerInit = () => {
  const wire = useWire();
  const stableUserId = createMemo(() => wire.auth.user()?.id);

  // Function to hide/show Featurebase widget based on screen size
  const toggleFeaturebaseVisibility = () => {
    const isMobile = window.innerWidth < 768;
    // Try multiple selectors to find the Featurebase widget
    const selectors = [
      "[data-featurebase-widget]",
      ".featurebase-widget",
      "#featurebase-widget",
      '[class*="featurebase"]',
      '[id*="featurebase"]',
    ];

    for (const selector of selectors) {
      const widget = document.querySelector(selector) as HTMLElement;
      if (widget) {
        if (isMobile) {
          widget.style.display = "none";
        } else {
          widget.style.display = "block";
        }
        break;
      }
    }
  };

  onMount(() => {
    // Initialize Featurebase
    if ("Featurebase" in window && typeof window.Featurebase === "function") {
      window.Featurebase("boot", {
        appId: "6697ed83c44f55af67e1cf19",
        theme: "light",
        language: "en",
        email: wire.auth.user()?.primaryEmail ?? "",
        id: wire.auth.user()?.id,
        name: wire.auth.user()?.displayName ?? "",
      });

      // Initialize changelog widget
      window.Featurebase("init_changelog_widget", {
        organization: "storytell",
        dropdown: {
          enabled: true,
          placement: "right",
        },
        popup: {
          enabled: true,
          usersName: wire.auth.user()?.displayName ?? "User",
          autoOpenForNewUpdates: true,
        },
        theme: "light",
        locale: "en",
      });
    }

    // Set up resize listener to hide/show widget based on screen size
    window.addEventListener("resize", toggleFeaturebaseVisibility);

    // Immediate check for mobile screens
    toggleFeaturebaseVisibility();

    // Multiple delayed checks to catch the widget as it loads
    setTimeout(toggleFeaturebaseVisibility, 500);
    setTimeout(toggleFeaturebaseVisibility, 1000);
    setTimeout(toggleFeaturebaseVisibility, 2000);
    setTimeout(toggleFeaturebaseVisibility, 3000);
    setTimeout(toggleFeaturebaseVisibility, 5000); // Final check

    // Use MutationObserver to watch for dynamically added elements
    const observer = new MutationObserver(() => {
      toggleFeaturebaseVisibility();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "id", "data-featurebase-widget"],
    });

    onCleanup(() => {
      window.removeEventListener("resize", toggleFeaturebaseVisibility);
      observer.disconnect();
    });
  });

  createEffect(
    on(stableUserId, (id) => {
      if (id) {
        if ("Featurebase" in window && typeof window.Featurebase === "function") {
          window.Featurebase("identify", {
            email: wire.auth.user()?.primaryEmail ?? "",
            id,
            name: wire.auth.user()?.displayName ?? "",
            organization: "Storytell",
          });
          window.Featurebase("boot", {
            appId: "6697ed83c44f55af67e1cf19",
            theme: "light",
            language: "en",
            email: wire.auth.user()?.primaryEmail ?? "",
            id,
            name: wire.auth.user()?.displayName ?? "",
          });

          // Re-initialize changelog widget with updated user info
          window.Featurebase("init_changelog_widget", {
            organization: "storytell",
            dropdown: {
              enabled: true,
              placement: "right",
            },
            popup: {
              enabled: true,
              usersName: wire.auth.user()?.displayName ?? "User",
              autoOpenForNewUpdates: true,
            },
            theme: "light",
            locale: "en",
          });
        }
      }
    }),
  );
  return null;
};
